<template>
  <v-container>

    <p class="headline text-center">
      Error 404: Page not found <br />
      <br />
      Well this is embarrassing! <br />
      <br />
      <a @click="$router.go(-1)">Go back to the previous page</a>
        </p>

  </v-container>

</template>

<script>

export default {
  name: 'Not Found',
  components: {

  },
  data () {
    return {
      errtext: null
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style scoped>

</style>
